import request from '@/utils/request'

export function login (username, password) {
  return request({
    url: '/admin/mchtLogin',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function adminBind(params) { // 微信绑定账号
  return request({
    url: '/api/z/adminBind',
    method: 'post',
    params
  })
}

export function getInfo () {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout () {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList (params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin (data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin (id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus (id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin (id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin (id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole (data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
// 下面部分为自主添加
export function register (data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function fetchSupplierList (data) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: data
  })
}

export function updateUser (id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data
  })
}

export function updatePassword (data) {
  return request({
    url: '/admin/updatePwd',
    method: 'post',
    data
  })
}

export function updateBindPhone (data) {
  return request({
    url: '/admin/updateBindPhone',
    method: 'post',
    data
  })
}

//用户日志列表
export function logRequest (params) {
  return request({
    url: '/admin/login/list',
    method: 'get',
    params: params
  })
}

// 获取配置信息
export function configData (params) {
  return request({
    url: '/api/z/sys/dict/list/key',
    method: 'get',
    params


  })
}
// 获取文章分类根据上级id
export function getNewsListByParentId (params) {
  return request({
    url: '/article/getListByParentId',
    method: 'get',
    params
  })
}
// 获取绑定信息
export function getBindingInformation (params) {
  return request({
    url: '/api/z/getBindingInformation',
    method: 'get',
    params
  })
}

// 发送手机短信验证码
export function getSmsCode (params) {
  return request({
    url: '/api/z/sendSms',
    method: 'post',
    params
  })
}

// 找回供应商密码
export function updatePasswords (params) {
  return request({
    url: '/api/z/retrieve',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js